function ScrollExecute() {
  if (
    $(document).height() - 800 <
    $(document).scrollTop() + $(window).height()
  ) {
    scrollNode = $("#ProductGridContainer #more").last();
    scrollURL = $("#ProductGridContainer #more p a").last().attr("href");
    if (scrollNode.length > 0 && scrollNode.css("display") != "none") {
      $.ajax({
        type: "GET",
        url: scrollURL,
        dataType: "html",
        beforeSend: function () {
          scrollNode
            .clone()
            .empty()
            .insertAfter(scrollNode)
            .append('<div id="loading-icon-wrapper"><img src="https://cdn.shopify.com/s/files/1/0066/2142/9817/files/loading.png?v=1692448305" /></div>');
          scrollNode.hide();
        },
        success: function (data) {
          scrollNode.next().remove();
          console.log(data);
          var filteredData = $(data).find("#ProductGridContainer div.collection.page-width");
          console.log(filteredData);
          $("#ProductGridContainer").append(filteredData);
        },
      });
    }
  }
}

$(document).ready(function () {
  $(window).scroll(function () {
    $.doTimeout("scroll", 200, ScrollExecute);
  });
});
